//
//
//
//

export default {
  props: {
    productDetails: { type: Object, default: () => {} },
    sku: { type: String, default: null }
  },
  computed: {
    cleanedSku () {
      let sku = this.sku || ''
      sku = sku.trim().toLowerCase()
      return sku
    },
    details () {
      if (Object.keys(this.productDetails || {}).length) return this.productDetails || {}
      return this.$store.getters['product/productDetails']((this.cleanedSku || '').split('-')[0]) || {}
    },
    rawName () {
      return (this.details.details || {}).name || ''
    },
    productName () {
      return this.rawName.replace(/Custom |™/gi, '')
    },
    showTM () {
      return this.rawName.endsWith('™')
    }
  }
}
